@if (isFetched && noteReport.length > 0) {
  <div class="flex flex-col gap-3">
    <!-- Caption -->
    <div class="flex items-center justify-between">
      <h3 class="font-semibold text-4">
        {{ translatePrefix + 'report' | translate }} {{ noteReportDate | date: 'MM/dd/yyyy HH:mm' }}
      </h3>

      <div *ngxPermissionsOnly="Permission.REPORT_EXPORT">
        <app-button
          (onClick)="exportMenu.toggle($event)"
          label="Export"
          size="sm"
          icon="icon-wl-upload"
          iconPosition="left"
          [isDropdown]="true"
          [loading]="isExporting"
          variant="outline-secondary"></app-button>
        <p-menu #exportMenu [model]="exportOptions" [popup]="true">
          <ng-template pTemplate="item" let-item>
            <div class="flex items-center gap-2 p-2 cursor-pointer">
              <img class="w-5 h-5" [src]="item.img" [alt]="item.title" />
              <span>{{ item.title }}</span>
            </div>
          </ng-template>
        </p-menu>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      @for (report of noteReport; track $index) {
        <app-note-item-report
          [index]="$index + 1 + pagination.page * pagination.size"
          [report]="report"
          [params]="params"
          [groupBy]="groupBy"
          (onSortChange)="onSort($event)"></app-note-item-report>
      }
    </div>

    <app-custom-paginator
      [(pagination)]="pagination"
      [totalRecords]="totalReports"
      [options]="options"
      (onChange)="onPagination()"></app-custom-paginator>
  </div>
} @else {
  @if (isFetched) {
    <app-empty title="No data" size="xs"></app-empty>
  }
}
